import React, { useEffect, useState, useRef } from "react";
import {
  Hamburger,
  NavCategory,
  NavCategoryItem,
  NavDivider,
  NavDrawer,
  NavDrawerBody,
  NavDrawerHeader,
  NavItem,
  NavSubItem,
  NavSubItemGroup,
  NavDrawerProps,
  NavItemValue,
  OnNavItemSelectData,
} from "@fluentui/react-nav-preview";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { makeStyles, tokens, Tooltip } from "@fluentui/react-components";
import apiServices from "../../service";
import { convertStringToArray, removeEmptyValues } from "../../utils";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { setDialogModalOptions } from "../../redux/modelDialogReducer";
import {
  setFormData,
  resetFormData,
  resetFormDataAsync,
} from "../../redux/reducer";
const useStyles = makeStyles({
  root: {
    overflow: "hidden",
    display: "flex",
    height: "calc(100vh - 150px)",
    width: "200px",
  },
  content: {
    flex: "1",
    padding: "16px",
    display: "grid",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  field: {
    display: "flex",
    marginTop: "4px",
    marginLeft: "8px",
    flexDirection: "column",
    gridRowGap: tokens.spacingVerticalS,
  },
  disabledNavItem: {
    color: tokens.colorNeutralForegroundDisabled,
    pointerEvents: "none",
    opacity: 0.9,
  },
});

function ClientPageSidebar(
  props: Partial<NavDrawerProps> & { [key: string]: any },
) {
  const dispatch: AppDispatch = useDispatch();
  const styles = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { clientId, assetId, mode } = useParams();
  const pathSegments = location.pathname.split("/");
  const activeClient: any = useSelector(
    (state: RootState) => state.activeClient,
  );
  const isFormDataUpdated = useSelector(
    (state: RootState) => state.someReducer?.isFormDataUpdated,
  );
  const [selectedMenu, setSelectedMenu] = useState<string>("");
  const [selectedCategoryValue, setSelectedCategoryValue] = useState<
    string | undefined
  >("");
  const [openCategories, setOpenCategories] = useState<NavItemValue[]>([]);

  const refs: any = {
    "client-summary": useRef(null),
    "case-summary": useRef(null),
    "contact-history": useRef(null),
    "name-and-address": useRef(null),
    contact: useRef(null),
    nationality: useRef(null),
    personal: useRef(null),
    "health-note": useRef(null),
    vulnerability: useRef(null),
    employment: useRef(null),
    "attitude-to-risk": useRef(null),
    identity: useRef(null),
    objectives: useRef(null),
    administration: useRef(null),
    compliance: useRef(null),
    "service-type": useRef(null),
    "user-defined": useRef(null),
    "partner-name-and-address": useRef(null),
    "partner-contact": useRef(null),
    "partner-nationality": useRef(null),
    "partner-personal": useRef(null),
    "partner-health-note": useRef(null),
    "partner-vulnerability": useRef(null),
    "partner-employment": useRef(null),
    "partner-attitude-to-risk": useRef(null),
    "partner-identity": useRef(null),
    "partner-objectives": useRef(null),

    "partner-service-type": useRef(null),
    dependant: useRef(null),

    income: useRef(null),
    outgoings: useRef(null),
    "address-book": useRef(null),
    assets: useRef(null),
    liabilities: useRef(null),
    policies: useRef(null),
    "fact-find-notes": useRef(null),
    "client-action": useRef(null),
    notes: useRef(null),
    "time-allocation": useRef(null),
    documents: useRef(null),
    "fees-charges": useRef(null),
  };

  const [clientInfo, setClientInfo] = useState<any>({});
  const [pageLoading, setPageLoading] = useState<boolean>(false);
  const [hasPartner, setHasPartner] = useState<boolean>(false);
  const [isDisableMenu, setIsDisableMenu] = useState<boolean>(false);
  const getClientId = "";
  useEffect(() => {
    if (pathSegments && pathSegments.length > 3) {
      if (pathSegments.includes("partner")) {
        setSelectedMenu(`partner-${pathSegments[4]}`);
        setSelectedCategoryValue("partner");
        setOpenCategories((prev) =>
          prev.includes("partner") ? prev : [...prev, "partner"],
        );
      } else if (pathSegments.includes("contacts")) {
        setSelectedMenu(pathSegments[4]);
        setSelectedCategoryValue("contacts");
        setOpenCategories((prev) =>
          prev.includes("contacts") ? prev : [...prev, "contacts"],
        );
      } else {
        const clientSections = [
          "name-and-address",
          "contact",
          "nationality",
          "personal",
          "health-note",
          "vulnerability",
          "employment",
          "attitude-to-risk",
          "identity",
          "objectives",
          "service-type",
          "user-defined",
          "administration",
          "compliance",
        ];

        if (clientSections.includes(pathSegments[3])) {
          setOpenCategories((prev) =>
            prev.includes("client") ? prev : [...prev, "client"],
          );
          setSelectedCategoryValue("client");
        } else {
          setSelectedCategoryValue("");
        }

        setSelectedMenu(pathSegments[3]);
      }
    }
  }, [pathSegments]);

  useEffect(() => {
    if (location.pathname == "/clients/add") {
      setIsDisableMenu(true);
    }
  }, [location]);
  useEffect(() => {
    Object.keys(refs).forEach((key) => {
      if (
        (pathSegments.includes(key) || pathSegments.includes("partner")) &&
        refs[key]?.current
      ) {
        refs[key].current.focus({ preventScroll: true });
      }
    });
  }, [location, clientId]);

  useEffect(() => {
    if (
      activeClient.basicDetails &&
      Object.keys(activeClient.basicDetails).length !== 0 &&
      activeClient.basicDetails.associated_type == 0 &&
      activeClient.basicDetails.associated_with !== null &&
      activeClient.basicDetails.associated_with !== ""
    ) {
      setHasPartner(true);
    }
  }, [activeClient]);

  const handleItemSelect = (
    ev: Event | React.SyntheticEvent<Element, Event>,
    data: OnNavItemSelectData,
  ) => {
    setSelectedCategoryValue(data.categoryValue as string);
    setSelectedMenu(data.value as string);
  };
  const handleCategoryToggle = (
    ev: Event | React.SyntheticEvent<Element, Event>,
    data: OnNavItemSelectData,
  ) => {
    // if it's already open, remove it from the list
    if (openCategories.includes(data.categoryValue as string)) {
      setOpenCategories([
        ...openCategories.filter((category) => category !== data.categoryValue),
      ]);
    } else {
      // otherwise add it
      setOpenCategories([...openCategories, data.categoryValue as string]);
    }
  };
  const checkFormStatus = (path: string) => {
    if (isFormDataUpdated) {
      dispatch(
        setDialogModalOptions({
          open: true,
          content_line_1:
            "We’ve detected an attempt to leave this page. If you have unsaved changes, they may be lost.",
          content_line_2: "Would you like to stay and review before exiting?",
          cancel: {
            onclick: () => {
              dispatch(
                setDialogModalOptions({
                  open: false,
                }),
              );
              dispatch(resetFormDataAsync()).then(() => {
                navigate(path);
              });
            },
            label: "Leave the Page",
          },
          no: {
            onclick: () => {
              dispatch(setDialogModalOptions({ open: false }));
            },
            label: "Stay on Page",
            type: "primary",
          },
        }),
      );
    } else {
      navigate(path);
    }
  };
  return (
    <div className={styles.root}>
      <NavDrawer
        type="inline"
        size="medium"
        open={true}
        style={{ overflow: "auto" }}
        onNavItemSelect={handleItemSelect}
        onNavCategoryItemToggle={handleCategoryToggle}
        selectedValue={selectedMenu}
        openCategories={openCategories}
        selectedCategoryValue={selectedCategoryValue}
        multiple={true}
      >
        <NavDrawerHeader>{props.renderIcon}</NavDrawerHeader>
        <NavDrawerBody className="sideNavBody" style={{ padding: 0 }}>
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "client_summary",
          ) && (
              <NavItem
                value="client-summary"
                ref={refs["client-summary"]}
                onClick={() =>
                  checkFormStatus(`/clients/${clientId}/client-summary`)
                }
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Client Summary
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "case_summary",
          ) && (
              <NavItem
                value="case-summary"
                ref={refs["case-summary"]}
                onClick={() =>
                  checkFormStatus(`/clients/${clientId}/case-summary`)
                }
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Case Summary
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "contact_history",
          ) && (
              <NavItem
                value="contact-history"
                ref={refs["contact-history"]}
                onClick={() =>
                  checkFormStatus(`/clients/${clientId}/contact-history`)
                }
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Contact History
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "client_portal",
          ) && (
              <NavItem
                value="client_portal"
                ref={refs["client_portal"]}
                onClick={() => navigate(`/clients/${clientId}/client_portal`)}
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Client Portal
              </NavItem>
            )}
          <NavDivider />

          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "client",
          ) && (
              <NavCategory value="client">
                <NavCategoryItem>Client</NavCategoryItem>
                <NavSubItemGroup>
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_NAME_ADDRESS") && (
                      <NavSubItem
                        value="name-and-address"
                        ref={refs["name-and-address"]}
                        onClick={
                          isDisableMenu
                            ? undefined
                            : () => {
                              checkFormStatus(
                                `/clients/${clientId}/name-and-address/view`,
                              );
                            }
                        }
                      >
                        Name and Address
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_CONTACT") && (
                      <NavSubItem
                        value="contact"
                        ref={refs["contact"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/contact/view`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Contact
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_NATIONALITY") && (
                      <NavSubItem
                        value="nationality"
                        ref={refs["nationality"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/nationality/view`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Nationality
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_PERSONAL") && (
                      <NavSubItem
                        value="personal"
                        ref={refs["personal"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/personal/view`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Personal
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_HEALTH_NOTE") && (
                      <NavSubItem
                        value="health-note"
                        ref={refs["health-note"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/health-note/view`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Health Note
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_VULNERABILITY") && (
                      <NavSubItem
                        value="vulnerability"
                        ref={refs["vulnerability"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/vulnerability`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Vulnerability
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_EMPLOYMENT") && (
                      <NavSubItem
                        value="employment"
                        ref={refs["employment"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/employment`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Employment
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_ATTITUDE_TO_RISK") && (
                      <NavSubItem
                        value="attitude-to-risk"
                        ref={refs["attitude-to-risk"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/attitude-to-risk`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Attitude to Risk
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_IDENTITY") && (
                      <NavSubItem
                        value="identity"
                        ref={refs["identity"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/identity`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Identity
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_OBJECTIVES") && (
                      <NavSubItem
                        value="objectives"
                        ref={refs["objectives"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/objectives`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Objectives
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("ADMINISTRATION") && (
                      <NavSubItem
                        value="administration"
                        ref={refs["administration"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/administration/view`,
                          )
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Administration
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("COMPLIANCE") && (
                      <NavSubItem
                        value="compliance"
                        ref={refs["compliance"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/compliance/view`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Compliance
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_SERVICE_TYPE") && (
                      <NavSubItem
                        value="service-type"
                        ref={refs["service-type"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/service-type`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        Service Type
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CLIENT_USER_DEFINED") && (
                      <NavSubItem
                        value="user-defined"
                        ref={refs["user-defined"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/user-defined`)
                        }
                        disabled={isDisableMenu ? true : false}
                        className={
                          isDisableMenu ? styles.disabledNavItem : undefined
                        }
                      >
                        User Defined
                      </NavSubItem>
                    )}
                </NavSubItemGroup>
              </NavCategory>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "partner",
          ) && (
              <NavCategory value="partner">
                <NavCategoryItem
                  disabled={isDisableMenu ? true : false}
                  className={isDisableMenu ? styles.disabledNavItem : undefined}
                >
                  Partner
                </NavCategoryItem>
                <NavSubItemGroup>
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_NAME_ADDRESS") && (
                      <NavSubItem
                        value="partner-name-and-address"
                        ref={refs["partner-name-and-address"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/partner/name-and-address/${hasPartner ? "view" : "add"
                            }`,
                          )
                        }
                      >
                        Name and Address
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_CONTACT") && (
                      <NavSubItem
                        value="partner-contact"
                        ref={refs["partner-contact"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/partner/contact`)
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Contact
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_NATIONALITY") && (
                      <NavSubItem
                        value="partner-nationality"
                        ref={refs["partner-nationality"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/partner/nationality`,
                          )
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Nationality
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_PERSONAL") && (
                      <NavSubItem
                        value="partner-personal"
                        ref={refs["partner-personal"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/partner/personal`)
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Personal
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_HEALTH_NOTE") && (
                      <NavSubItem
                        value="partner-health-note"
                        ref={refs["partner-health-note"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/partner/health-note`,
                          )
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Health Note
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_VULNERABILITY") && (
                      <NavSubItem
                        value="partner-vulnerability"
                        ref={refs["partner-vulnerability"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/partner/vulnerability`,
                          )
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Vulnerability
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_EMPLOYMENT") && (
                      <NavSubItem
                        value="partner-employment"
                        ref={refs["partner-employment"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/partner/employment`)
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Employment
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_ATTITUDE_TO_RISK") && (
                      <NavSubItem
                        value="partner-attitude-to-risk"
                        ref={refs["partner-attitude-to-risk"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/partner/attitude-to-risk`,
                          )
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Attitude to Risk
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_IDENTITY") && (
                      <NavSubItem
                        value="partner-identity"
                        ref={refs["partner-identity"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/partner/identity`)
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Identity
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_OBJECTIVES") && (
                      <NavSubItem
                        value="partner-objectives"
                        ref={refs["partner-objectives"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/partner/objectives`)
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Objectives
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("PARTNER_SERVICE_TYPE") && (
                      <NavSubItem
                        value="partner-service-type"
                        ref={refs["partner-service-type"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/partner/service-type`,
                          )
                        }
                        disabled={hasPartner ? false : true}
                        className={hasPartner ? undefined : styles.disabledNavItem}
                      >
                        Service Type
                      </NavSubItem>
                    )}
                </NavSubItemGroup>
              </NavCategory>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "DEPENDANTS",
          ) && (
              <NavItem
                value="dependant"
                ref={refs["dependant"]}
                onClick={() => checkFormStatus(`/clients/${clientId}/dependant`)}
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Dependants
              </NavItem>
            )}
          <NavDivider />
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "INCOME",
          ) && (
              <NavItem
                value="income"
                ref={refs["income"]}
                onClick={() => checkFormStatus(`/clients/${clientId}/income`)}
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Income
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "OUTGOINGS",
          ) && (
              <NavItem
                value="outgoings"
                ref={refs["outgoings"]}
                onClick={() => checkFormStatus(`/clients/${clientId}/outgoings`)}
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Outgoings
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "ADDRESS",
          ) && (
              <NavItem
                value="address-book"
                ref={refs["address-book"]}
                onClick={() =>
                  checkFormStatus(`/clients/${clientId}/address-book`)
                }
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Address Book
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "ASSESTS",
          ) && (
              <NavItem
                value="assets"
                ref={refs["assets"]}
                onClick={() => checkFormStatus(`/clients/${clientId}/assets`)}
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Assets
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "LIABILITIES",
          ) && (
              <NavItem
                value="liabilities"
                ref={refs["liabilities"]}
                onClick={() =>
                  checkFormStatus(`/clients/${clientId}/liabilities`)
                }
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Liabilities
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "POLIICIES",
          ) && (
              <NavItem
                value="policies"
                ref={refs["policies"]}
                onClick={() => checkFormStatus(`/clients/${clientId}/policies`)}
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Policies
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "FACT-FIND NOTES",
          ) && (
              <NavItem
                value="fact-find-notes"
                ref={refs["fact-find-notes"]}
                onClick={() =>
                  checkFormStatus(`/clients/${clientId}/fact-find-notes`)
                }
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Fact-find Note
              </NavItem>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "FEES/CHARGES",
          ) && (
              <NavItem
                value="fees-charges"
                ref={refs["fees-charges"]}
                onClick={() =>
                  checkFormStatus(`/clients/${clientId}/fees-charges`)
                }
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Fees/Charges
              </NavItem>
            )}
          <NavDivider />
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "CONTACT",
          ) && (
              <NavCategory value="contacts">
                <NavCategoryItem
                  disabled={isDisableMenu ? true : false}
                  className={isDisableMenu ? styles.disabledNavItem : undefined}
                >
                  Contacts
                </NavCategoryItem>
                <NavSubItemGroup>
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CONTACTS_CLIENT_ACTION") && (
                      <NavSubItem
                        value="client-action"
                        ref={refs["client-action"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/contacts/client-action`,
                          )
                        }
                      >
                        Client Action
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CONTACTS_NOTES") && (
                      <NavSubItem
                        value="notes"
                        ref={refs["notes"]}
                        onClick={() =>
                          checkFormStatus(`/clients/${clientId}/contacts/notes`)
                        }
                      >
                        Notes
                      </NavSubItem>
                    )}
                  {!convertStringToArray(
                    process.env.REACT_APP_HIDE_SIDE_TAB,
                  ).includes("CONTACTS_TIME_ALLOCATION") && (
                      <NavSubItem
                        value="time-allocation"
                        ref={refs["time-allocation"]}
                        onClick={() =>
                          checkFormStatus(
                            `/clients/${clientId}/contacts/time-allocation`,
                          )
                        }
                      >
                        Time Allocation
                      </NavSubItem>
                    )}
                </NavSubItemGroup>
              </NavCategory>
            )}
          {!convertStringToArray(process.env.REACT_APP_HIDE_SIDE_TAB).includes(
            "DOCUMENTS",
          ) && (
              <NavItem
                value="documents"
                ref={refs["documents"]}
                onClick={() => checkFormStatus(`/clients/${clientId}/documents`)}
                disabled={isDisableMenu ? true : false}
                className={isDisableMenu ? styles.disabledNavItem : undefined}
              >
                Documents
              </NavItem>
            )}
        </NavDrawerBody>
      </NavDrawer>
    </div>
  );
}

export default ClientPageSidebar;
